import styled from 'styled-components'

export const PunchOutOrderInfoTooltipStyled = styled.div`
  padding: 1em;
  max-width: ${(props) => props.theme.typography.pxToRem(250)};
`
